import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from 'react-markdown'
//Importing Material UI stuff
import { OutlinedButton } from "../../components/Buttons";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Box, Typography, Card } from "@material-ui/core";

import style from "./style";
import "./style.css";
import remarkGfm from 'remark-gfm'

import externalLink from "../../assets/social-icons/external-link.svg";
import github from "../../assets/social-icons/github2.svg";

const useStyles = makeStyles(style);

const fetchProjectDetails = async (projectData, id) => {
  const project = projectData.find((element) => element.id === parseInt(id));

  return await fetch(project.content)
    .then((response) => response.text())
    .then(text => {
      return text;
    });
}

const ProjectPage = ({ projectData }) => {
  const classes = useStyles();
  let params = useParams();
  const [markdownContent, setMarkdownContent] = useState("");
  const project = projectData.find((element) => element.id === parseInt(params.id));

  useEffect(async () => {
    const data = await fetchProjectDetails(projectData, params.id);
    setMarkdownContent(data);
  }, [projectData, params.id]);

  return (
    <>
      <Typography data-aos="fade-in" variant="h2" className={classes.title}>
        {project.title}
      </Typography>
      <Box>
        <Grid className={classes.wrapper}>
          <Grid container>
            <Box>
              <Typography
                data-aos="fade-in"
                className={classes.subHeading}
                gutterBottom
                variant="h5"
                component="h4"
              >
                Description:
              </Typography>
              <Typography
                data-aos="fade-in"
                variant="h6"
                gutterBottom
                className={classes.description}
              >
                {project.description}
              </Typography>

              <Box className={`${classes.linkContainer}`}>
                {project.sourceCode && (
                  <Typography
                    data-aos="fade-in"
                    variant="h6"
                    gutterBottom
                    className={classes.link}
                  >
                    <a
                      data-aos="fade-in"
                      href={project.sourceCode}
                      target="_blank"
                      rel="noreferrer"
                      className={`${classes.linkhover} hover-detect`}
                    >
                      Source Code
                      <img width={16} height={16} src={github} alt="github link"/>
                    </a>

                  </Typography>
                )}
                {project.projectLink && (
                  <Typography
                    variant="h6"
                    gutterBottom
                    className={classes.link}
                    href={project.projectLink}
                  >
                    <a
                      data-aos="fade-in"
                      target="_blank"
                      rel="noreferrer"
                      href={project.projectLink}
                      className={`${classes.linkhover} hover-detect`}
                    >
                      Vist Project
                      <img width={16} height={16} src={externalLink} alt="external link"/>
                    </a>

                  </Typography>
                )}
              </Box>
            </Box>
          </Grid>

          <Grid container className={classes.rightContainer}>
            <Grid>
              <Typography
                data-aos="fade-in"
                gutterBottom
                variant="h5"
                component="h4"
                className={classes.subHeading}
              >
                Role:
              </Typography>

              <Typography
                data-aos="fade-in"
                variant="h6"
                gutterBottom
                className={classes.description}
              >
                {project.roles}
              </Typography>
            </Grid>
            <Grid>
              <Typography
                data-aos="fade-in"
                gutterBottom
                variant="h5"
                component="h4"
                className={classes.subHeading}
              >
                Technologies/Tools:
              </Typography>

              <Typography
                data-aos="fade-in"
                variant="h6"
                gutterBottom
                className={classes.description}
              >
                {project.technology}
              </Typography>
            </Grid>
            <Grid>
              <Typography
                data-aos="fade-in"
                gutterBottom
                variant="h5"
                component="h4"
                className={classes.subHeading}
              >
                Client:
              </Typography>

              <Typography
                data-aos="fade-in"
                variant="h6"
                gutterBottom
                className={classes.description}
              >
                {project.clients}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {/* Markdown Content Start */}
      <div id="markdown-content" data-aos="fade-in" data-aos-delay="100" className="markdown">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {markdownContent}
        </ReactMarkdown>
      </div>
      {/* Embed links */}
      <Card className={classes.card}>
        {project.embedLinks.map((embeds, id) => {
          return <iframe
            data-aos="fade-in" data-aos-delay="100"
            src={embeds}
            title="Embed Player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            className={`${ classes.embed } `}
            allowFullScreen
            key={id}
          ></iframe>
        })}
      </Card>
      {/* Back to Projects Button */}
      <Typography
        gutterBottom
        variant="h5"
        component="h4"
        className={classes.nextContainer}
      >
        <Link to={`/projects`} className="hover-detect">
          <OutlinedButton data-aos="fade-in" size="large">Back to Projects</OutlinedButton>
        </Link>
      </Typography>

    </>

  );
};

export default ProjectPage;